"use strict";

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.Browser = void 0;
var _requester = require("../requester"),
  _types = require("./types"),
  _types2 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var Browser = /*#__PURE__*/function () {
  function Browser(a, b) {
    _classCallCheck(this, Browser);
    _defineProperty(this, "status", void 0), _defineProperty(this, "browser", void 0), _defineProperty(this, "version", void 0), this.browser = a, this.version = b, this.status = _types2.TrackingStatus.Unsent;
  }
  return _createClass(Browser, [{
    key: "url",
    get: function get() {
      if (!this.browser) return "";
      var a = this.version ? _requester.UrlParameter.BrowserVersion + this.version : "";
      return _requester.UrlEventType.StaticData + _requester.UrlParameter.Browser + this.browser + _requester.UrlParameter.BrowserIndex + _types.BrowserIndexMap[this.browser] + a;
    }
  }, {
    key: "data",
    get: function get() {
      return {
        browser: this.browser,
        type: _types.KameleoonData.Browser,
        version: this.version,
        status: this.status
      };
    }
  }], [{
    key: "_fromRaw",
    value: function _fromRaw(a) {
      var b = a.browser,
        c = a.version,
        d = a.status,
        e = new Browser(b, c);
      return e.status = d, e;
    }
  }, {
    key: "_fromVisit",
    value: function _fromVisit(a) {
      if (a.staticDataEvent) {
        var _a$staticDataEvent$da = a.staticDataEvent.data,
          b = _a$staticDataEvent$da.browser,
          c = _a$staticDataEvent$da.browserIndex,
          d = _a$staticDataEvent$da.browserVersion;
        if (b || "number" == typeof c) {
          var _a = null !== b && void 0 !== b ? b : _types.BrowserTypeMap[c];
          return d ? new Browser(_a, d) : new Browser(_a);
        }
      }
    }
  }]);
}();
exports.Browser = Browser;